import React, { Component } from "react";
import { Link } from "react-router-dom";

import { getPagePath } from "./../../helpers/system";

import Logo from "./logo";

export default class HeaderMini extends Component {
    renderLogo(homeLink) {
        const { darkmode = false, type = false } = this.props;

        return (
            <span className="header-logo">
                <Logo darkmode={darkmode} link={homeLink} type={type} />
            </span>
        );
    }

    render() {
        const { type = false } = this.props;
        let homeLink = getPagePath("HomePage");
        let spanContent = "SeekCap website";
        if (type === "motorcycles") {
            homeLink = getPagePath("MotorcyclesHomePage");
            spanContent = "CitySavings Bank website";
        }

        return (
            <header id="main-header-mini">
                {this.renderLogo(homeLink)}
                <nav className="header-nav">
                    <Link to={homeLink} title="Go back to SeekCap website">
                        Go back to <span>{spanContent}</span>
                    </Link>
                </nav>
            </header>
        );
    }
}
